// extracted by mini-css-extract-plugin
export var MarkdownTextFullPageContainer = "index-module--MarkdownTextFullPageContainer--37rvD";
export var MarkdownTextFullPageFlexContainer = "index-module--MarkdownTextFullPageFlexContainer--XGdoF";
export var MarkdownTextFullPageHeadingContainer = "index-module--MarkdownTextFullPageHeadingContainer--Xk5+9";
export var MarkdownTextFullPageInnerFlexContainer = "index-module--MarkdownTextFullPageInnerFlexContainer--Moe98";